import { actionTypes } from "./actions";

const initialState = {
  data: {},
  resendCustomers: false,
  cancelResend: false,
  resendData: [],
  allIngestions: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_INGESTION_MONITOR:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_RESEND_CUSTOMERS_TO_SAP:
      return {
        ...state,
        resendCustomers: payload,
      };

    case actionTypes.SET_ALL_INGESTIONS:
      return {
        ...state,
        allIngestions: payload,
      };

    case actionTypes.SET_RESEND_CUSTOMER_DATA:
      return {
        ...state,
        resendData: payload,
      };

    case actionTypes.SET_CANCEL_RESEND:
      return {
        ...state,
        cancelResend: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
